import {
  CreditCard,
  Layout,
  Sliders,
  Settings,
  Italic,
  Mail,
  FileText,
  BookOpen,
  Info,
  Folder,
  Server,
  Tag,
} from "react-feather";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import DownloadIcon from "@mui/icons-material/Download";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { FaAws } from "react-icons/fa6";
import { VscAzure } from "react-icons/vsc";
import { FaGoogle } from "react-icons/fa6";
import NetworkLockedIcon from "@mui/icons-material/NetworkLocked";
import { LockKeyhole, Monitor, Vault, VaultIcon, Cloud, Bot, ShieldCheckIcon } from "lucide-react";
const pagesSection = [
  {
    href: "/dashboard",
    icon: Sliders,
    title: "Dashboard",
    children: [
      {
        href: "/dashboard/overview",
        title: "Overview",
      },
      {
        href: "/dashboard/lolbin",
        title: "LOLBin",
      },
      {
        href: "/dashboard/alerts",
        title: "Alerts",
      },
      {
        href: "/dashboard/agenticactivity",
        title: "Agentic Activity",
      },
    ],
  },
  {
    href: "/incidents",
    icon: Italic,
    title: "Incidents",
    children: [
      {
        href: "/auditLogs",
        title: "Device Audit Logs",
      },
      /* {
        href: "/deviceDebugLogs",
        title: "Device Debug Logs",
      }, */
      {
        href: "/serverAuditLogs",
        title: "Platform Audit Logs",
      },
      /* {
        href: "/serverDebugLogs",
        title: "Server Debug Logs",
      }, */
    ],
  },
  {
    icon: Bot,
    title: "Agentic Gateway",
    newTag: true,
    children: [
      {
        href: "/agentic-gateway/health",
        title: "Health Overview",
      },
      {
        href: "/agentic-gateway/config",
        title: "Configuration",
      },
      {
        href: "/agentic-gateway/servers",
        title: "MCP Servers",
      },
      {
        href: "/agentic-gateway/agents",
        title: "AI Agents",
      },
      {
        href: "/agentic-gateway/identities",
        title: "Identities",
      },
      {
        href: "/agentic-gateway/profiles",
        title: "Capability Profiles",
      },
      {
        href: "/agentic-gateway/policies",
        title: "Policies",
      },
      {
        href: "/agentic-gateway/inflight",
        title: "In-Flight",
      },
      {
        href: "/agentic-gateway/audit",
        title: "Audit Log",
      },
      {
        href: "/agentic-gateway/playground",
        title: "Playground",
      },
    ],
  },
  {
    href: "/activeDirectory",
    icon: Folder,
    title: "Active Directory",
    children: [
      {
        href: "/activeDirectory/analytics",
        title: "Analytics",
      },

      {
        href: "/activeDirectory/management",
        title: "User Membership",
      },
    ],
  },
  {
    href: "/cloud",
    icon: Cloud,
    title: "Cloud",
    children: [
      {
        href: "/cloud/policy-autopilot",
        title: "Policy Autopilot",
      },
      {
        href: "/cloud/cloud-alert-management",
        title: "Alert Management",
      },
      {
        href: "/cloud/cloud-dashboard",
        title: "NHI Dashboard",
      },
      {
        href: "/cloud/cloud-analytics",
        title: "Cloud Graph",
      },
    ],
  },
  {
    href: "/aws",
    icon: FaAws,
    title: "Aws",
    children: [
      {
        href: "/aws/cloud-alerts",
        title: "Alerts",
      },
      // {
      //   href: "/aws/awsalerts",
      //   title: "Alerts",
      // },
      {
        href: "/aws/users",
        title: "Users",
      },
      {
        href: "/aws/nhis",
        title: "NHI",
      },
      {
        href: "/aws/roles",
        title: "Roles",
      },
      {
        href: "/aws/groups",
        title: "Groups",
      },

      {
        href: "/aws/resources",
        title: "Resources",
      },
      /* {
        href: "/aws/resourceRequest",
        title: "Resource Request",
      }, */
    ],
  },
  {
    href: "/azure-directory",
    icon: VscAzure,
    title: "Azure",
    children: [
      {
        href: "/azure-directory/cloud-alerts",
        title: "Alerts",
      },
      // {
      //   href: "/azure-directory/azurealerts",
      //   title: "Alerts",
      // },
      {
        href: "/azure-directory/devices",
        title: "Devices",
      },
      {
        href: "/azure-directory/azureusers",
        title: "Users",
      },
      {
        href: "/azure-directory/nhis",
        title: "NHI",
      },
      {
        href: "/azure-directory/roles",
        title: "Roles",
      },

      {
        href: "/azure-directory/groups",
        title: "Groups",
      },
      {
        href: "/azure-directory/resources",
        title: "Resources",
      },
    ],
  },
  {
    href: "/gcp",
    icon: FaGoogle,
    title: "GCP",
    children: [
      {
        href: "/gcp/cloud-alerts",
        title: "Alerts",
      },
      // {
      //   href: "/gcp/gcpalerts",
      //   title: "Alerts",
      // },
      {
        href: "/gcp/gcpusers",
        title: "Users",
      },
      {
        href: "/gcp/nhis",
        title: "NHI",
      },

      {
        href: "/gcp/roles",
        title: "Roles",
      },

      {
        href: "/gcp/resources",
        title: "Resources",
      },
    ],
  },
  {
    href: "/configuredSaasApps",
    icon: Cloud,
    title: "SaaS Apps",
  },
  {
    href: "/endpoints",
    icon: Monitor,
    title: "Endpoints",
  },
  {
    href: "/endpointGroups",
    icon: Server,
    title: "Endpoint Groups",
  },

  {
    href: "/tags",
    icon: Tag,
    title: "Tags",
  },
  {
    href: "/webUrls",
    icon: NetworkLockedIcon,
    title: "Web Urls",
  },
  {
    href: "/vault-services",
    icon: LockKeyhole,
    title: "Vault Service",
  },
  {
    href: "/policyProfiles",
    icon: Layout,
    title: "Policy Profiles",
  },
  {
    href: "/resourceCategories",
    icon: BookOpen,
    title: "Resource Categories",
  },
  {
    href: "/resourceRequests",
    icon: Mail,
    title: "Resource Requests",
    badge: true,
  },
  {
    icon: SupervisorAccountIcon,
    title: "User Management",
    children: [
      {
        href: "/userInvites",
        title: "Invite Users",
      },
      {
        href: "/adUsers",
        title: "Active Directory Users",
      },
      {
        href: "/registeredUsers",
        title: "Registered Users",
      },
      {
        href: "/roles",
        title: "User Roles",
      },
    ],
  },
  {
    // href: "/tenantManagement",
    icon: InsertInvitationIcon,
    title: "Tenant Management",
    children: [
      {
        href: "/tenantDetails",
        title: "Tenant Details",
      },
      {
        href: "/approval-policy",
        icon: ShieldCheckIcon,
        title: "Approval Policy",
      },

      {
        href: "/tenantSettings",
        title: "Settings",
      },

    ],
  },

  {
    href: "/account",
    icon: Settings,
    title: "Account",
  },
  {
    href: "/reports",
    icon: FileText,
    title: "Reports",
    children: [
      {
        href: "/reports/overProvisioning",
        title: "Over-provisioning",
      },
      // {
      //   href: "/historical-data",
      //   title: "Historical-data",
      //   children: [
      //     {
      //       href: "/reports/privilegeCreep",
      //       title: "Privilege creep",
      //     },
      //   ],
      // },
    ],
  },

  {
    href: "/downloads",
    icon: DownloadIcon,
    title: "Downloads",
  },
  {
    href: "/about",
    icon: Info,
    title: "About",
  },
];

const epamUserPagesSection = [
  {
    href: "/aws",
    icon: FaAws,
    title: "Aws",
    children: [
      {
        href: "/aws/users",
        title: "Resources",
      },
      {
        href: "/aws/kubernetes",
        title: "Kubernetes",
      },
    ],
  },

  {
    href: "/azure-directory",
    icon: VscAzure,
    title: "Azure",
    children: [
      {
        href: "/azure-directory/azureusers",
        title: "Resources",
      },
      {
        href: "/azure-directory/kubernetes",
        title: "Kubernetes",
      },
    ],
  },

  {
    href: "/gcp",
    icon: FaGoogle,
    title: "GCP",
    children: [
      {
        href: "/gcp/gcpusers",
        title: "Users",
      },
    ],
  },

  {
    href: "/endpoints",
    icon: Monitor,
    title: "Endpoints",
  },

  {
    href: "/userResourceRequests",
    icon: Mail,
    title: "Resource Requests",
    badge: true,
  },
  {
    href: "/account",
    icon: Settings,
    title: "Account",
  },
  {
    href: "/downloads",
    icon: DownloadIcon,
    title: "Downloads",
  },
  {
    href: "/about",
    icon: Info,
    title: "About",
  },
];

const usersPagesSection = [
  {
    href: "/aws",
    icon: FaAws,
    title: "Aws",
    children: [
      {
        href: "/aws/users",
        title: "Resources",
      },
      {
        href: "/aws/kubernetes",
        title: "Kubernetes",
      },
    ],
  },

  {
    href: "/azure-directory",
    icon: VscAzure,
    title: "Azure",
    children: [
      {
        href: "/azure-directory/azureusers",
        title: "Resources",
      },
      {
        href: "/azure-directory/kubernetes",
        title: "Kubernetes",
      },
    ],
  },

  {
    href: "/gcp",
    icon: FaGoogle,
    title: "GCP",
    children: [
      {
        href: "/gcp/gcpusers",
        title: "Resources",
      },
      {
        href: "/gcp/kubernetes",
        title: "Kubernetes",
      },
    ],
  },

  {
    href: "/endpoints",
    icon: Monitor,
    title: "Endpoints",
  },
  {
    href: "/webUrls",
    icon: NetworkLockedIcon,
    title: "Web Urls",
  },

  {
    href: "/userResourceRequests",
    icon: Mail,
    title: "Resource Requests",
    badge: true,
  },
  {
    href: "/account",
    icon: Settings,
    title: "Account",
  },
  {
    href: "/downloads",
    icon: DownloadIcon,
    title: "Downloads",
  },
  {
    href: "/about",
    icon: Info,
    title: "About",
  },
];
const epamAdminSection = [
  {
    href: "/dashboard",
    icon: Sliders,
    title: "Dashboard",
    children: [
      {
        href: "/dashboard/overview",
        title: "Overview",
      },
      {
        href: "/dashboard/lolbin",
        title: "LOLBin",
      },
      {
        href: "/dashboard/alerts",
        title: "Alerts",
      },
    ],
  },
  {
    href: "/incidents",
    icon: Italic,
    title: "Incidents",
    children: [
      {
        href: "/auditLogs",
        title: "Device Audit Logs",
      },
      /* {
        href: "/deviceDebugLogs",
        title: "Device Debug Logs",
      }, */
      {
        href: "/serverAuditLogs",
        title: "Platform Audit Logs",
      },
      /* {
        href: "/serverDebugLogs",
        title: "Server Debug Logs",
      }, */
    ],
  },
  {
    href: "/activeDirectory",
    icon: Folder,
    title: "Active Directory",
    children: [
      {
        href: "/activeDirectory/analytics",
        title: "Analytics",
      },

      {
        href: "/activeDirectory/management",
        title: "User Membership",
      }
    ],
  },

  {
    href: "/endpoints",
    icon: Monitor,
    title: "Endpoints",
  },
  {
    href: "/endpointGroups",
    icon: Server,
    title: "Endpoint Groups",
  },

  {
    href: "/tags",
    icon: Tag,
    title: "Tags",
  },
  {
    href: "/policyProfiles",
    icon: Layout,
    title: "Policy Profiles",
  },
  {
    href: "/resourceCategories",
    icon: BookOpen,
    title: "Resource Categories",
  },
  {
    href: "/resourceRequests",
    icon: Mail,
    title: "Resource Requests",
    badge: true,
  },
  {
    icon: SupervisorAccountIcon,
    title: "User Management",
    children: [
      {
        href: "/userInvites",
        title: "Invite Users",
      },
      {
        href: "/adUsers",
        title: "Active Directory Users",
      },
      {
        href: "/registeredUsers",
        title: "Registered Users",
      },
      {
        href: "/roles",
        title: "User Roles",
      },
    ],
  },
  {
    // href: "/tenantManagement",
    icon: InsertInvitationIcon,
    title: "Tenant Management",
    children: [
      {
        href: "/tenantDetails",
        title: "Tenant Details",
      },
      {
        href: "/approval-policy",
        icon: ShieldCheckIcon,
        title: "Approval Policy",
      }


    ],
  },
  {
    href: "/account",
    icon: Settings,
    title: "Account",
  },
  {
    href: "/reports",
    icon: FileText,
    title: "Reports",
    children: [
      {
        href: "/reports/overProvisioning",
        title: "Over-provisioning",
      },
    ],
  },

  {
    href: "/downloads",
    icon: DownloadIcon,
    title: "Downloads",
  },
  {
    href: "/about",
    icon: Info,
    title: "About",
  },
];

const serverPamSection = [
  {
    href: "/dashboard",
    icon: Sliders,
    title: "Dashboard",
    children: [
      {
        href: "/dashboard/overview",
        title: "Overview",
      },
      {
        href: "/dashboard/lolbin",
        title: "LOLBin",
      },
      {
        href: "/dashboard/alerts",
        title: "Alerts",
      },
    ],
  },
  {
    href: "/incidents",
    icon: Italic,
    title: "Incidents",
    children: [
      {
        href: "/auditLogs",
        title: "Device Audit Logs",
      },
      /*  {
        href: "/deviceDebugLogs",
        title: "Device Debug Logs",
      }, */
      {
        href: "/serverAuditLogs",
        title: "Platform Audit Logs",
      },
      /* {
        href: "/serverDebugLogs",
        title: "Server Debug Logs",
      }, */
    ],
  },
  {
    href: "/aws",
    icon: FaAws,
    title: "Aws",
    children: [
      {
        href: "/aws/cloud-alerts",
        title: "Alerts"
      },
      // {
      //   href: "/aws/awsalerts",
      //   title: "Alerts",
      // },
      {
        href: "/aws/users",
        title: "Users",
      },
      {
        href: "/aws/nhis",
        title: "NHI",
      },
      {
        href: "/aws/roles",
        title: "Roles",
      },
      {
        href: "/aws/groups",
        title: "Groups",
      },

      {
        href: "/aws/resources",
        title: "Resources",
      },
      /* {
        href: "/aws/resourceRequest",
        title: "Resource Request",
      }, */
    ],
  },
  {
    href: "/azure-directory",
    icon: VscAzure,
    title: "Azure",
    children: [
      {
        href: "/azure-directory/cloud-alerts",
        title: "Alerts",
      },
      // {
      //   href: "/azure-directory/azurealerts",
      //   title: "Alerts",
      // },
      {
        href: "/azure-directory/devices",
        title: "Devices",
      },
      {
        href: "/azure-directory/azureusers",
        title: "Users",
      },
      {
        href: "/azure-directory/nhis",
        title: "NHI",
      },

      {
        href: "/azure-directory/roles",
        title: "Roles",
      },
      {
        href: "/azure-directory/groups",
        title: "Groups",
      },
      {
        href: "/azure-directory/resources",
        title: "Resources",
      },
    ],
  },
  {
    href: "/gcp",
    icon: FaGoogle,
    title: "GCP",
    children: [
      {
        href: "/gcp/cloud-alerts",
        title: "Alerts"
      },
      // {
      //   href: "/gcp/gcpalerts",
      //   title: "Alerts",
      // },
      {
        href: "/gcp/gcpusers",
        title: "Users",
      },
      {
        href: "/gcp/nhis",
        title: "NHI",
      },
      {
        href: "/gcp/roles",
        title: "Roles",
      },

      {
        href: "/gcp/resources",
        title: "Resources",
      },
    ],
  },
  {
    href: "/endpoints",
    icon: Monitor,
    title: "Endpoints",
  },
  {
    href: "/endpointGroups",
    icon: Server,
    title: "Endpoint Groups",
  },

  {
    href: "/tags",
    icon: Tag,
    title: "Tags",
  },
  {
    href: "/webUrls",
    icon: NetworkLockedIcon,
    title: "Web Urls",
  },
  {
    href: "/vault-services",
    icon: LockKeyhole,
    title: "Vault Service",
  },
  {
    href: "/policyProfiles",
    icon: Layout,
    title: "Policy Profiles",
  },
  {
    href: "/resourceCategories",
    icon: BookOpen,
    title: "Resource Categories",
  },
  {
    href: "/resourceRequests",
    icon: Mail,
    title: "Resource Requests",
    badge: true,
  },
  {
    icon: SupervisorAccountIcon,
    title: "User Management",
    children: [
      {
        href: "/userInvites",
        title: "Invite Users",
      },
      /*   {
        href: "/registeredUsers",
        title: "Registered Users",
      }, */
      {
        href: "/registeredUsers",
        title: "Registered Users",
      },
      {
        href: "/roles",
        title: "User Roles",
      },
    ],
  },
  {
    // href: "/tenantManagement",
    icon: InsertInvitationIcon,
    title: "Tenant Management",
    children: [
      {
        href: "/tenantDetails",
        title: "Tenant Details",
      },
      {
        href: "/approval-policy",
        icon: ShieldCheckIcon,
        title: "Approval Policy",
      },
    ],
  },
  {
    href: "/account",
    icon: Settings,
    title: "Account",
  },
  {
    href: "/reports",
    icon: FileText,
    title: "Reports",
    children: [
      {
        href: "/reports/overProvisioning",
        title: "Over-provisioning",
      },
    ],
  },

  {
    href: "/downloads",
    icon: DownloadIcon,
    title: "Downloads",
  },
  {
    href: "/about",
    icon: Info,
    title: "About",
  },
];

export const adminNavsItems = [
  {
    title: "",
    pages: [...pagesSection],
  },
];
export const sysAdminNavsItems = [
  {
    title: "",
    pages: [...pagesSection],
  },
];

export const userNavsItems = [
  {
    title: "",
    pages: usersPagesSection,
  },
];

export const epamNavsItems = [
  {
    title: "",
    pages: [...epamAdminSection],
  },
];
export const serverPamNavsItems = [
  {
    title: "",
    pages: [...serverPamSection],
  },
];
export const epamUserNavsItems = [
  {
    title: "",
    pages: [...epamUserPagesSection],
  },
];
